// States.tsx
export const countries = [
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
];

export const states = [
  { value: "ALABAMA", label: "ALABAMA", short: "AL" },
  { value: "ALASKA", label: "ALASKA", short: "AK" },
  { value: "ARIZONA", label: "ARIZONA", short: "AZ" },
  { value: "ARKANSAS", label: "ARKANSAS", short: "AR" },
  { value: "CALIFORNIA", label: "CALIFORNIA", short: "CA" },
  { value: "COLORADO", label: "COLORADO", short: "CO" },
  { value: "CONNECTICUT", label: "CONNECTICUT", short: "CT" },
  { value: "DC", label: "DC", short: "DC" },
  { value: "DELAWARE", label: "DELAWARE", short: "DE" },
  { value: "FLORIDA", label: "FLORIDA", short: "FL" },
  { value: "GEORGIA", label: "GEORGIA", short: "GA" },
  { value: "HAWAII", label: "HAWAII", short: "HI" },
  { value: "IDAHO", label: "IDAHO", short: "ID" },
  { value: "ILLINOIS", label: "ILLINOIS", short: "IL" },
  { value: "INDIANA", label: "INDIANA", short: "IN" },
  { value: "IOWA", label: "IOWA", short: "IA" },
  { value: "KANSAS", label: "KANSAS", short: "KS" },
  { value: "KENTUCKY", label: "KENTUCKY", short: "KY" },
  { value: "LOUISIANA", label: "LOUISIANA", short: "LA" },
  { value: "MAINE", label: "MAINE", short: "ME" },
  { value: "MARYLAND", label: "MARYLAND", short: "MD" },
  { value: "MASSACHUSETTS", label: "MASSACHUSETTS", short: "MA" },
  { value: "MICHIGAN", label: "MICHIGAN", short: "MI" },
  { value: "MINNESOTA", label: "MINNESOTA", short: "MN" },
  { value: "MISSISSIPPI", label: "MISSISSIPPI", short: "MS" },
  { value: "MISSOURI", label: "MISSOURI", short: "MO" },
  { value: "MONTANA", label: "MONTANA", short: "MT" },
  { value: "NEBRASKA", label: "NEBRASKA", short: "NE" },
  { value: "NEVADA", label: "NEVADA", short: "NV" },
  { value: "NEW HAMPSHIRE", label: "NEW HAMPSHIRE", short: "NH" },
  { value: "NEW JERSEY", label: "NEW JERSEY", short: "NJ" },
  { value: "NEW MEXICO", label: "NEW MEXICO", short: "NM" },
  { value: "NEW YORK", label: "NEW YORK", short: "NY" },
  { value: "NORTH CAROLINA", label: "NORTH CAROLINA", short: "NC" },
  { value: "NORTH DAKOTA", label: "NORTH DAKOTA", short: "ND" },
  { value: "OHIO", label: "OHIO", short: "OH" },
  { value: "OKLAHOMA", label: "OKLAHOMA", short: "OK" },
  { value: "OREGON", label: "OREGON", short: "OR" },
  { value: "PENNSYLVANIA", label: "PENNSYLVANIA", short: "PA" },
  { value: "PUERTO RICO", label: "PUERTO RICO", short: "PR" },
  { value: "RHODE ISLAND", label: "RHODE ISLAND", short: "RI" },
  { value: "SOUTH CAROLINA", label: "SOUTH CAROLINA", short: "SC" },
  { value: "SOUTH DAKOTA", label: "SOUTH DAKOTA", short: "SD" },
  { value: "TENNESSEE", label: "TENNESSEE", short: "TN" },
  { value: "TEXAS", label: "TEXAS", short: "TX" },
  { value: "UTAH", label: "UTAH", short: "UT" },
  { value: "VERMONT", label: "VERMONT", short: "VT" },
  { value: "VIRGINIA", label: "VIRGINIA", short: "VA" },
  { value: "WASHINGTON", label: "WASHINGTON", short: "WA" },
  { value: "WEST VIRGINIA", label: "WEST VIRGINIA", short: "WV" },
  { value: "WISCONSIN", label: "WISCONSIN", short: "WI" },
  { value: "WYOMING", label: "WYOMING", short: "WY" },
];

export const provinces = [
  { value: "ALBERTA", label: "ALBERTA", short: "AB" },
  { value: "BRITISH COLUMBIA", label: "BRITISH COLUMBIA", short: "BC" },
  { value: "MANITOBA", label: "MANITOBA", short: "MB" },
  { value: "NEW BRUNSWICK", label: "NEW BRUNSWICK", short: "NB" },
  { value: "NEWFOUNDLAND AND LABRADOR", label: "NEWFOUNDLAND AND LABRADOR", short: "NL" },
  { value: "NORTHWEST TERRITORIES", label: "NORTHWEST TERRITORIES", short: "NT" },
  { value: "NOVA SCOTIA", label: "NOVA SCOTIA", short: "NS" },
  { value: "NUNAVUT", label: "NUNAVUT", short: "NU" },
  { value: "ONTARIO", label: "ONTARIO", short: "ON" },
  { value: "PRINCE EDWARD ISLAND", label: "PRINCE EDWARD ISLAND", short: "PE" },
  { value: "QUEBEC", label: "QUEBEC", short: "QC" },
  { value: "SASKATCHEWAN", label: "SASKATCHEWAN", short: "SK" },
  { value: "YUKON", label: "YUKON", short: "YT" },
];

// Helper function to get states/provinces based on country
export const getStatesProvinces = (country: string) => {
  return country === "CA" ? provinces : states;
};

// Helper function to get the label for state/province field
export const getStateProvinceLabel = (country: string) => {
  return country === "CA" ? "Province" : "State";
};

// Helper function to get the label for zip/postal code field
export const getZipPostalLabel = (country: string) => {
  return country === "CA" ? "Postal Code" : "Zip Code";
};

// Canadian EFT validation
export const validateTransitNumber = (transitNumber: string): boolean => {
  return /^\d{5}$/.test(transitNumber);
};

export const validateInstitutionNumber = (institutionNumber: string): boolean => {
  return /^\d{3}$/.test(institutionNumber);
};

// Postal code / Zip code validation
export const validateZipCode = (zipCode: string): boolean => {
  return /^\d{5}$/.test(zipCode);
};

export const validatePostalCode = (postalCode: string): boolean => {
  // Canadian postal code format: A1A 1A1 or A1A1A1
  const cleanedPostalCode = postalCode.replace(/\s/g, "").toUpperCase();
  return /^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(cleanedPostalCode);
};

export const validateZipOrPostalCode = (value: string, country: string): boolean => {
  if (!value) return true;
  if (country === "CA") {
    return validatePostalCode(value);
  }
  return validateZipCode(value);
};

export const formatPostalCode = (value: string): string => {
  // Remove all spaces and convert to uppercase
  const cleaned = value.replace(/\s/g, "").toUpperCase();
  // Insert space after 3rd character if length > 3
  if (cleaned.length > 3) {
    return cleaned.slice(0, 3) + " " + cleaned.slice(3, 6);
  }
  return cleaned;
};

// Payment mode options based on country
export const getPaymentModeOptions = (country: string) => {
  if (country === "CA") {
    return ["EFT", "WIRE", "CHECK"];
  }
  return ["ACH", "WIRE", "CHECK", "RCC"];
};

// Banking field label helper
export const getBankingNumberLabel = (country: string, modeOfPayment: string) => {
  if (country === "CA" && modeOfPayment === "EFT") {
    return "Transit Number";
  }
  return "ABA/Routing Number";
};
